import analytics from '@utils/analytics';
import classNames from 'classnames';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ModalDialog from '@ui/modal/ModalDialog';
const InstantMessageBox = (props) => {
    const { t } = useTranslation();
    const [offlinePopup, setOfflinePopup] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    if (!props.instantMessage || (window.country == 'JP' && window.faf)) {
        return React.createElement(React.Fragment, null);
    }
    const instantMessageLink = (classname, labelkey) => {
        if (props.instantMessage == 'whatsapp') {
            let whatsappnumber = props.instantMessageNumber;
            return (React.createElement("a", { className: classNames(classname, 'whatsapp'), href: `https://wa.me/${whatsappnumber}`, target: "_blank", onClick: () => {
                    analytics.contactUsOne('instantmessage');
                } },
                React.createElement("span", null,
                    labelkey ? t(labelkey, { 0: 'WhatsApp' }) : 'WhatsApp',
                    " ")));
        }
        if (props.instantMessage == 'kakao') {
            return (React.createElement("a", { className: classNames(classname, 'kakao'), href: "http://pf.kakao.com/_TQLDC/chat", target: "_blank", onClick: () => {
                    analytics.contactUsOne('instantmessage');
                } },
                React.createElement("span", null,
                    labelkey ? t(labelkey, { 0: 'KAKAO TALK' }) : 'KAKAO TALK',
                    " ")));
        }
        if (props.instantMessage == 'line') {
            return (React.createElement("a", { className: classNames(classname, 'linechat'), href: "https://line.me/R/ti/p/@545ncrrm", target: "_blank", onClick: () => {
                    analytics.contactUsOne('instantmessage');
                } },
                React.createElement("span", null,
                    labelkey ? t(labelkey, { 0: 'Line' }) : 'Line',
                    " ")));
        }
        if (props.instantMessage == 'wechat') {
            return (React.createElement(React.Fragment, null,
                React.createElement("button", { className: classNames(classname, 'wechat'), type: "button", onClick: (e) => {
                        setOpenModal(true);
                        analytics.contactUsOne('instantmessage');
                    } },
                    React.createElement("span", null, labelkey ? t(labelkey, { 0: 'WeChat' }) : 'Line'))));
        }
        if (props.instantMessage == 'sms') {
            let smsNumber = props.instantMessageNumber;
            return (React.createElement(React.Fragment, null,
                React.createElement("a", { className: classNames(classname, 'sms'), href: `sms:${smsNumber}`, target: "_blank", onClick: (e) => {
                        analytics.contactUsOne('instantmessage');
                    } },
                    React.createElement("span", null, labelkey ? t(labelkey, { 0: 'iMessage/SMS/MMS' }) : 'iMessage/SMS/MMS'))));
        }
    };
    if (props.type == 'footer') {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", null, instantMessageLink('', 'footer.clientservice.instantmessagecontact')),
            props.instantMessage && props.instantMessage == 'wechat' && (React.createElement(React.Fragment, null,
                React.createElement(ModalDialog, { overlayClassName: "mobile-visible", isOpen: openModal, onRequestClose: () => {
                        setOpenModal(false);
                    }, className: "client-service__modal--small client-service__modal--offline modal--small", role: "dialog", contentLabel: t(`clientservice.contactsdetails.qr.title.wechat`) },
                    React.createElement("p", null, t(`clientservice.contactsdetails.qr.subtitle.wechat`)),
                    React.createElement("div", { className: "contacts-image-container" },
                        React.createElement("img", { src: window.socialQrImageFolder + props.instantMessageRegion + '-' + props.instantMessage + '-qrcode.jpg', alt: "", width: "152", height: "152" }))),
                React.createElement(ModalDialog, { overlayClassName: "mobile-visible", contentLabel: t('clientservice.contactsdetails.offlinechannel.title'), className: "client-service__modal--small client-service__modal--offline modal--small", isOpen: offlinePopup, role: "dialog", onRequestClose: () => {
                        setOfflinePopup(false);
                    } },
                    React.createElement("p", null, t('clientservice.contactsdetails.offlinechannel.description')))))));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "row link-box line" },
            React.createElement("div", { className: "col-lg-8 col-md-6 col-sm-7 col-xs-12" },
                React.createElement("h3", { className: "link-box__title" }, t('clientservice.instantmessages')),
                React.createElement("p", { className: "col-sm-10" },
                    t('contacts.instantmessagetime'),
                    " ")),
            React.createElement("div", { className: "col-lg-4 col-md-6 col-sm-5 col-xs-12 " }, instantMessageLink('link-box__button button button--secondary', '')))));
};
export default InstantMessageBox;
